<div [formGroup]="userPasswordForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="password"
    [maskContent]="true"
    label="Passwort">
  </nx-edit-text-input>
  <nx-checkbox-text-input
    formControlName="updatePassword"
    label="Nutzer muss Passwort bei der nächsten Anmeldung ändern
    ">
  </nx-checkbox-text-input>
<div>